<template>
  <div class="container-fluid my-5 px-5">
    <div class="row">
      <div class="col-12">
        <h1>Gerenciar de Roteiros</h1>
        <p class="text-end">
        <router-link to="/roteirospublic">Exibição de roteiros</router-link> <br><br>
        <router-link to="/roteirosadminmes">Integridade do mês</router-link> <br><br>
        <router-link to="/power">Power</router-link> <br><br>
        </p>
        <p>Você deve <mark>sempre salvar</mark> ao modificar um roteiro.</p>
        <p>Modifique um por vez e clique em salvar.</p>
        <p>Isso garante a individualização de cada roteiro escolhido e editado.</p>

      </div>
      <div class="col-12">
        <label for="dataselec" class="mb-3">Selecione a data para avaliar, ativar ou desativar, editar roteiros:</label>
        <input id="dataselec" type="date" :min="today" v-model="selectedDate" @change="fetchData" v-if="!editMode" />
      </div>
      <div class="col-12">
        <button class="btn btn-primary" @click="toggleEditMode">Roteiro instruções <span v-if="editMode">modo de edição
            ativo</span></button>
       
      </div>

    </div>
    <div class="row mt-5 mb-2">
      <div class="col-12">
        <button class="btn btn-dark" @click="toggleView">{{ isExpandedView ? 'Versão reduzida' : 'Versão ampliada'
          }}</button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div v-if="isExpandedView" class="row mt-3">
          <div class="col-12 text-end">
            <button class="btn btn-primary" @click="saveAll">Salvar todas as modificações</button>
            <table class="table">
              <thead>
                <tr>

                  <th>Nome</th>
                  <th>Data</th>
                  <th>Status</th>
                  <th>Descrição</th>
                  <th>Vagas/Restrições</th>
                  <th>Duração</th>

                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.codigo" :class="{ 'inativo': item.ativo === '0' }">

                  <td style="position:relative"><input v-model="item.titulo" /> <span
                      style="position:absolute;bottom:0px;left:0px; word-break: break-all;"> código: {{ item.codigo
                      }}</span></td>
                  <td>{{ item.diasem }} <br> {{ item.datedisplay }}<br> {{ formatHorario(item.codigo) }}</td>

                  <td>
                    <span class="status-reserva" :class="statusReservaClass(item)">
                      {{ statusReservaLabel(item) }}
                    </span>
                    <span v-if="obterTicketReserva(item)" class="ticket-reserva">
                      Ticket {{ obterTicketReserva(item) }}
                    </span>
                  </td>

                  <td><textarea v-model="item.descricao"></textarea></td>

                  <td><input v-model="item.vagas" /> <br><br><textarea v-model="item.restricoes"></textarea></td>
                  <td><input class="w-50" v-model="item.duracao" /></td>

                  <td style="text-align: end;">
                    <button @click="toggleAtivo(item)" class="mt-0 w-100"
                      :class="{ 'btn-ativo': item.ativo === '1', 'btn-inativo': item.ativo === '0' }">
                      {{ item.ativo === '1' ? 'ON' : 'OFF' }}
                    </button> <br><br>
                    <button @click="updateItem(item)" :disabled="loading"
                      class="w-100 btn btn-success mt-0">Salvar</button>
                    <span v-if="item.codigo === updatingCodigo && loading">Salvando...</span>
                    <span v-if="item.codigo === updatingCodigo && !loading && success">Salvo!</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else id="tabela-icones" class="d-flex flex-wrap gap-2 my-4">
          <div v-for="item in items" :key="item.codigo"
            :class="['locus-posicao', { 'inativo': item.ativo === '0', 'expandido': item.expandido }]">
            <div class="d-flex flex-column justify-content-center">
              <span class="status-reserva" :class="statusReservaClass(item)">
                {{ statusReservaLabel(item) }}
              </span>
              <span v-if="obterTicketReserva(item)" class="ticket-reserva">
                Ticket {{ obterTicketReserva(item) }}
              </span>
              <span>
                {{ formatHorario(item.codigo) }}
              </span>
              <span style="font-size: 12px;">
                Posição: {{ formatPosicao(item.codigo) }}
              </span>
              <button class="btn" :class="item.expandido ? 'btn-danger' : 'btn-light'" @click="expandDiv(item)">{{
                item.expandido ? 'fechar' : 'expandir' }}</button>
            </div>
            <div><input v-model="item.titulo" /> <span> código: {{ item.codigo }}</span></div>
            <div>{{ item.datedisplay }}</div>
            <div>{{ item.diasem }}</div>
            <div><label for="descricao">Descrição:</label> <textarea id="descricao" v-model="item.descricao"></textarea>
            </div>
            <div><label for="vagas">Vagas:</label> <input id="vagas" v-model="item.vagas" /></div>
            <div><label for="restricoes">Restrições</label> <textarea id="restricoes"
                v-model="item.restricoes"></textarea></div>
            <div><label for="duracao">Duração</label> <input id="duracao" v-model="item.duracao" /></div>
            <div>
              <div class="d-flex justify-content-center gap-5">
                <button @click="toggleAtivo(item)" class="mt-0"
                  :class="{ 'btn-ativo': item.ativo === '1', 'btn-inativo': item.ativo === '0' }">
                  {{ item.ativo === '1' ? 'ON' : 'OFF' }}
                </button>
                <button @click="updateItem(item)" :disabled="loading" class="btn btn-success mt-0">Salvar</button>
                <span v-if="item.codigo === updatingCodigo && loading">Salvando...</span>
                <span v-if="item.codigo === updatingCodigo && !loading && success">Salvo!</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';

export default {
  setup() {
    const today = new Date().toISOString().split('T')[0];
    const selectedDate = ref(today);
    const items = ref([]);
    const loading = ref(false);
    const success = ref(false);
    const updatingCodigo = ref(null);
    const isExpandedView = ref(false);
    const editMode = ref(false);

    const formatDateToDDMMYYYY = (date) => {
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    };

    const fetchData = async () => {
      const formattedDate = formatDateToDDMMYYYY(selectedDate.value);
      try {
        const response = await axios.get(`https://museucatavento.org.br/sistema-agendamento/apiroteiros2.php`, {
          params: { datedisplay: formattedDate }
        });
        items.value = response.data.map(item => ({
          ...item,
          ativo: item.ativo.toString(), // Garantir que o valor de ativo seja uma string
          expandido: false
        }));
        console.log(items.value);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    const fetchData2 = async () => {

      try {
        const response = await axios.get(`https://museucatavento.org.br/sistema-agendamento/apiroteiros3.php`);
        items.value = response.data.map(item => ({
          ...item,
          ativo: item.ativo.toString(), // Garantir que o valor de ativo seja uma string
          expandido: false
        }));
        console.log(items.value);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    

    const toggleEditMode = () => {
      editMode.value = !editMode.value;
      if (editMode.value) {
        fetchData2();
      }
    }

    const criarPayloadRoteiro = (item) => ({
      codigo: item.codigo,
      titulo: item.titulo,
      diasem: item.diasem,
      datedisplay: item.datedisplay,
      descricao: item.descricao,
      vagas: item.vagas,
      restricoes: item.restricoes,
      duracao: item.duracao,
      ativo: item.ativo,
    });

    const updateItem = async (item) => {
      loading.value = true;
      updatingCodigo.value = item.codigo;
      success.value = false;
      try {
        await axios.post(`https://museucatavento.org.br/sistema-agendamento/apiroteiros_update.php`, criarPayloadRoteiro(item));
        console.log('Item atualizado com sucesso');
        success.value = true;
        setTimeout(() => {
          success.value = false;
        }, 2000);
      } catch (error) {
        console.error('Erro ao atualizar item:', error);
      } finally {
        loading.value = false;
        updatingCodigo.value = null;
      }
    };

    const saveAll = async () => {
      loading.value = true;
      try {
        for (const item of items.value) {
          await updateItem(item);
        }
        alert('Todos os itens foram atualizados com sucesso');
      } catch (error) {
        console.error('Erro ao atualizar todos os itens:', error);
      } finally {
        loading.value = false;
      }
    };

    const toggleAtivo = (item) => {
      item.ativo = item.ativo === '1' ? '0' : '1';
    };

    const expandDiv = (item) => {
      item.expandido = !item.expandido;
    };

    const toggleView = () => {
      isExpandedView.value = !isExpandedView.value;
    };

    const normalizarStatus = (item) => String(item?.aprovacao ?? item?.estadoaprovacao ?? "");

    const obterTicketReserva = (item) => {
      return item?.bid || item?.ticket || item?.idticket || item?.idreserva || item?.reserva || "";
    };

    const roteiroReservado = (item) => {
      return normalizarStatus(item) === "2" || Boolean(obterTicketReserva(item));
    };

    const statusReservaLabel = (item) => {
      if (roteiroReservado(item)) return "Reservado";
      if (normalizarStatus(item) === "4") return "Cancelamento solicitado";
      return item.ativo === "1" ? "Livre" : "Inativo";
    };

    const statusReservaClass = (item) => {
      if (roteiroReservado(item)) return "status-reservado";
      if (normalizarStatus(item) === "4") return "status-cancelamento";
      return item.ativo === "1" ? "status-livre" : "status-inativo";
    };

    const formatHorario = (codigo) => {
      const hora = codigo.substring(8, 10);
      const minutos = codigo.substring(10, 12);
      return `${hora}:${minutos}`;
    };
    const formatPosicao = (codigo) => {
      const posicao = codigo.substring(14, 16);
      return posicao;
    };

    onMounted(() => {
      fetchData(); // Busca os dados para a data atual ao carregar a página
    });

    return {
      today,
      selectedDate,
      items,
      fetchData,
      fetchData2,
      formatHorario,
      formatPosicao,
      obterTicketReserva,
      updateItem,
      toggleAtivo,
      toggleEditMode,
      expandDiv,
      editMode,
      toggleView,
      loading,
      success,
      updatingCodigo,
      isExpandedView,
      statusReservaClass,
      statusReservaLabel,
      saveAll
    };
  }
};
</script>

<style scoped>
.container-fluid {

  margin-left: auto;
  margin-right: auto;
}

tr {
  vertical-align: middle;

}

td {
  width: 16%;
  text-align: center;
}

th {
  text-align: center;
  padding-right: 20px;
}

input,
select,
textarea {
  width: 100%;
}

button {
  padding: 0.45rem 0.75rem;
  margin-top: 10px;
  cursor: pointer;
}

span {
  margin-left: 10px;
}

tr.inativo>td,
.inativo {
  background-color: #e2979d9e !important;
  /* Exemplo de cor para itens inativos */
}

.btn-ativo {
  background-color: var(--catavento-blue, #165a96);
  color: white;
  border: 0;
}

.btn-inativo {
  background-color: #5a6268;
  color: white;
  border: 0;
}

.status-reserva {
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.76rem;
  font-weight: 800;
  justify-content: center;
  margin: 0.15rem 0;
  min-height: 28px;
  padding: 0.25rem 0.65rem;
  text-align: center;
}

.ticket-reserva {
  color: #243447;
  display: block;
  font-size: 0.8rem;
  font-weight: 800;
  margin: 0.2rem 0 0;
  overflow-wrap: anywhere;
}

.status-reservado {
  background: #fde8e8;
  color: #9b1c1c;
}

.status-cancelamento {
  background: #fff3cd;
  color: #7a5b00;
}

.status-livre {
  background: #e6f4ed;
  color: #176847;
}

.status-inativo {
  background: #eef1f5;
  color: #475467;
}

.locus-posicao {
  background-color: #e7f4ea;
  padding: 1rem;
  border-radius: var(--catavento-radius, 8px);
  border: 1px solid #badbcc;
  transition: all 0.3s ease;
  min-width: 150px;
}

.locus-posicao>div:nth-child(n+2) {
  display: none;
}

.locus-posicao.expandido {
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: row;
  align-items: stretch;
  overflow-x: auto;
}

.locus-posicao.expandido>div:nth-child(n+2) {
  display: block;
  min-width: 180px;
}

table {
  min-width: 920px;
}

.table {
  border-color: var(--catavento-border, #d9e1ea);
}

.table input,
.table textarea {
  min-width: 120px;
}

@media (max-width: 991px) {
  .col-12.text-end {
    overflow-x: auto;
  }
}

@media (max-width: 767px) {
  .container-fluid {
    margin-top: 1.5rem !important;
  }

  .locus-posicao {
    width: 100%;
  }

  .locus-posicao.expandido {
    flex-direction: column;
    overflow-x: visible;
  }

  .locus-posicao.expandido>div:nth-child(n+2) {
    min-width: 0;
  }

  .d-flex.justify-content-center.gap-5 {
    flex-direction: column;
    gap: 0.75rem !important;
  }
}

</style>
